import React, { Component } from "react";
import { tokens, removeStorage, getStorage } from "../components/CustomComponent.js";
import "../assets/css/bootstrap.css";

export default class LoadingScreen extends Component {
  componentDidMount() {
    let first_page = getStorage("first_page");
    let project_id = getStorage("project_id");
    if (tokens && first_page) {
      window.location.href = project_id ? first_page : "/choose-project";
    } else {
      removeStorage();
      window.location.href = "/login";
    }
  }
  render() {
    return <div></div>;
  }
}
